import fetch from './fetch'

class WholeProcessApi {
	public getWPList(form: any) {
		return fetch({
			url: 'injury/wholeprocess/case/list',
			method: 'POST',
			data: form,
		})
	}

	public getWPDetail(id: string) {
		return fetch({
			url: 'injury/wholeprocess/case/detail',
			method: 'GET',
			params: {
				id,
			},
		})
	}

	public getInjuryTaskList(id: string) {
		return fetch({
			url: 'injury/wholeprocess/case/taskList',
			method: 'GET',
			params: {
				id,
			},
		})
	}

	public stopProcess(form: any) {
		return fetch({
			url: 'injury/wholeprocess/endProcess',
			method: 'post',
			data: form,
		})
	}
}

export default new WholeProcessApi()
